import { EligibilityCodeValidationModel, EligibilityValidationRequest } from 'app/shared/constants/common.model';
import { store } from 'app/shared/store/store';
import { getHeaders } from 'app/shared/utilities/helper-functions';

class EligibilityCodeRespositoryService {
  public post = async (request: EligibilityValidationRequest): Promise<EligibilityCodeValidationModel> => {
    const configData = store.get('configData');
    const requestUrl = `${configData?.bffApiUrl}/promocode/validateeligibilitycode`;

    try {
      const response = await fetch(requestUrl, {
        method: 'POST',
        body: JSON.stringify({
          ...request
        }),
        headers: getHeaders()
      });
      return await response.json();
    } catch (error) {
      return error;
    }
  };
}

export const eligibilityCodeRespositoryService = new EligibilityCodeRespositoryService();
